import React from 'react';

export function EmptyState() {
  return (
    <div className="text-center py-12">
      <div className="max-w-md mx-auto">
        <div className="text-6xl mb-4">👥</div>
        <h3 className="text-xl font-semibold text-gray-800 mb-2">
          Invite a teammate!
        </h3>
        <p className="text-gray-600">
          Share the join link with your team members to start voting together.
        </p>
      </div>
    </div>
  );
}


